import { useActiveAdsQuery } from '../../store/features/ads/adsSlice';
import { AdPosition } from '../../types/ads';
import { useLocation } from 'react-router-dom';
import { A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box, alpha } from '@mui/material';

// Swiper css
import 'swiper/css';

interface AppAdsProps {
  position: AdPosition;
}

const AUTOPLAY_DELAY_IN_MILLISECONDS = 10000;

export const AppAds: React.FC<AppAdsProps> = ({ position }) => {
  const location = useLocation();
  const { ads } = useActiveAdsQuery(location.pathname, {
    selectFromResult: (state) => ({ ads: state.data?.filter((ad) => ad.position === position) }),
  });
  if (!ads || ads.length === 0) return null;
  return (
    <Box
      className="container-fluid"
      sx={{
        bgcolor: (theme) => alpha(theme.palette.warning.light, 0.5),
        borderTop: 1,
        borderBottom: 1,
        borderColor: 'divider',
        mb: position === 'Middle' ? 2 : 0,
      }}
    >
      <Swiper
        modules={[A11y, Autoplay]}
        autoplay={{
          delay: AUTOPLAY_DELAY_IN_MILLISECONDS,
          pauseOnMouseEnter: true,
          disableOnInteraction: true,
        }}
        spaceBetween={24}
        slidesPerView="auto"
      >
        {ads.map((ad) => (
          <SwiperSlide key={ad.id} style={{ width: ad.size === 'Full' ? '100%' : '50%' }}>
            <Box
              component="a"
              sx={{
                my: 1,
                display: 'flex',
                justifyContent: 'center',
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: 1,
                borderColor: 'divider',
              }}
              href={ad.link}
              target="_blank"
              rel="noopener"
            >
              {ad.media.filetype.startsWith('video') ? (
                <Box
                  component="video"
                  src={ad.media.link}
                  sx={{
                    display: 'block',
                    borderRadius: 'inherit',
                    objectFit: 'contain',
                    objectPosition: 'center',
                    flex: 1,
                    height: 160,
                    maxWidth: '100%',
                  }}
                  muted
                  autoPlay
                  controls
                />
              ) : (
                <Box
                  component="img"
                  src={ad.media.link}
                  sx={{
                    display: 'block',
                    borderRadius: 'inherit',
                    objectFit: 'contain',
                    objectPosition: 'center',
                    flex: 1,
                    height: 160,
                    maxWidth: '100%',
                  }}
                  alt={ad.link}
                />
              )}
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
